module.exports = __webpack_public_path__ + "static/media/contentTitle@2x.4a898255.png";